import { useMemo } from "react";
import { getHolidaysForYear, type HolidayEntry } from "../data/public-holidays";
export type { HolidayEntry } from "../data/public-holidays";

/**
 * Retourne une Map des jours fériés et dates notables pour les dates affichées.
 */
export function useHolidays(days: readonly string[]): ReadonlyMap<string, HolidayEntry> {
  return useMemo(() => {
    const years = new Set(days.map((d) => parseInt(d.slice(0, 4), 10)));
    const holidays = new Map<string, HolidayEntry>();
    for (const year of years) {
      if (isNaN(year)) continue;
      for (const [date, entry] of getHolidaysForYear(year)) {
        holidays.set(date, entry);
      }
    }
    return holidays;
  }, [days]);
}
